// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"803843a1","647":"4bfa8cd0"}[chunkId] + ".chunk.js";
};